import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@ngx-translate/core';

class AriaAttributesDirective {
    constructor(elementRef, renderer, translateService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.translateService = translateService;
    }
    ngOnInit() {
        this.translatedLabel = this.translateService.instant(this.ariaLabelTranslation || ' ');
        this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-label', this.translatedLabel);
    }
    ngAfterViewInit() {
        const inputElements = this.elementRef.nativeElement.querySelectorAll('input, textarea, button, label');
        if (inputElements && inputElements.length > 0) {
            inputElements.forEach((elem) => {
                elem.setAttribute('aria-label', this.translatedLabel);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AriaAttributesDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: AriaAttributesDirective, selector: "[ariaAttributes]", inputs: { ariaLabelTranslation: "ariaLabelTranslation" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AriaAttributesDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ariaAttributes]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.TranslateService }]; }, propDecorators: { ariaLabelTranslation: [{
                type: Input
            }] } });

class AccesibilityModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccesibilityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AccesibilityModule, declarations: [AriaAttributesDirective], exports: [AriaAttributesDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccesibilityModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccesibilityModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AriaAttributesDirective],
                    imports: [],
                    exports: [AriaAttributesDirective],
                }]
        }] });

/*
 * Public API Surface of accesibility
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccesibilityModule, AriaAttributesDirective };
